import { useState } from 'react';

import ComplaintModalContainer from '@containers/ComplaintModalContainer';
import CanComplainContainer from '@containers/CanComplainContainer';

// types
type CreateComplainProps = {
  username: string;
  productId?: number
};

export const CreateComplain: React.FC<CreateComplainProps> = ({
  username,
  productId,
}) => {
  const [canComplain, allowComplain] = useState(false);
  const [step, increaseStep] = useState(1);
  const [complaintId, setComplaintId] = useState(null);
  const [userId, setUserId] = useState<number | null>(null);
  return (
    <>
      <CanComplainContainer
        username={username}
        allowComplain={allowComplain}
        setUserId={setUserId}
        productPage={productId !== undefined}
      />
      {
        canComplain && userId
          ? (
            <ComplaintModalContainer
              canComplain={canComplain}
              allowComplain={allowComplain}
              step={step}
              increaseStep={increaseStep}
              complaintId={complaintId}
              setComplaintId={setComplaintId}
              userId={userId}
              productId={productId}
            />
          ) : null
      }
    </>
  );
};

export default CreateComplain;
